import React, {useEffect, useState} from "react";
import {Button, CloseButton} from "react-bootstrap";
import {MdBackspace, MdCall, MdDialpad} from "react-icons/md";
import axios from "axios";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {setDialNumber, setHasDialAbility, setShowDial} from "../../../../_reducers/crmSlice";
import "./callcenter-style.css";

const DialUp = () => {
    const dispatch = useDispatch();
    const maxLength = 15;
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const telephoneId = JSON.parse(localStorage.getItem("user"))?.telephoneId;

    const showDial = useSelector((state) => state.CRM.showDial);
    const dialNumber = useSelector((state) => state.CRM.dialNumber);

    const [loading, setLoading] = useState(false);

    const [selectedFrom, setSelectedFrom] = useState("");

    useEffect(() => {
        if (!isEmpty(telephoneId)) {
            const split = String(telephoneId).split(",");
            setSelectedFrom(split[0]);
            dispatch(setHasDialAbility(true));
        }
    }, [telephoneId]);

    const dialContainerStyle = {
        position: "absolute",
        width: "280px",
        bottom: "60px",
        backgroundColor: "#ffffff",
        zIndex: 1000,
        borderRadius: "20px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
        border: "1px solid #e0e0e0",
        overflow: "hidden",
        fontFamily: "'Inter', system-ui, sans-serif",
        padding: "15px",
    }

    const gridStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "5px",
        justifyItems: "center",
    }

    const backButtonStyle = {
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "transparent",
        border: "none",
        color: "#5f6368",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "22px",
    }

    const click = (val) => {
        if (val === "backspace") {
            dispatch(setDialNumber(String(dialNumber).slice(0, -1)));
        } else if (String(dialNumber + val).length < 15) {
            dispatch(setDialNumber(String(dialNumber + val)));
        }
    }

    const onChange = (e) => {
        if (String(e.target.value).length <= 15) {
            dispatch(setDialNumber(e.target.value));
        }
    }

    const onCall = () => {
        if (isEmpty(dialNumber)) return toast.info("Παρακαλώ συμπληρώστε ένα νούμερο.");

        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/callcenter/call-originate`, {
            company: company.id,
            from: selectedFrom,
            to: dialNumber,
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setShowDial(false));
                toast.success("Επιτυχής εκκίνηση κλήσης. Παρακαλώ σηκώστε το τηλέφωνο σας.");
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος");
        })
    }

    return (
        <React.Fragment>
            <Button size={"sm"} className="ml-1" style={{padding: "5px"}} onClick={() => dispatch(setShowDial(!showDial))}>
                <MdDialpad size={20}/>
            </Button>

            {showDial && (
                <div style={dialContainerStyle}>
                    <div>
                        <h6 style={{textAlign: "center", fontSize: "20px", paddingTop: "5px"}}>
                            Εσωτερικό: <strong>{selectedFrom ? selectedFrom : "-"}</strong>
                        </h6>
                        <CloseButton style={{position: "absolute", right: "10px", top: "10px"}} onClick={() => dispatch(setShowDial(false))}/>
                    </div>
                    {!selectedFrom ? (
                        <div style={{padding: "10px"}}>Η λειτουργία είναι απενεργοποιήμενη για εσάς. Δεν βρέθηκε συνδεδεμένο εσωτερικό νούμερο στον χρήστη σας.</div>
                    ) : (
                        <React.Fragment>
                            <div style={{textAlign: "center", padding: "10px", wordBreak: "break-all"}}>
                                <input
                                    style={{textAlign: "center"}}
                                    value={dialNumber}
                                    className={"dial-up-input"}
                                    onChange={(e) => onChange(e)}
                                    maxLength={maxLength}
                                    type={"number"}
                                    placeholder={"000 000 0000"}
                                />
                            </div>
                            <div style={gridStyle}>
                                {["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", ""].map((num) => {
                                    if (num === "") return <div key={`dialUp-${num}`} className={"dial-up-button-disabled"}></div>
                                    else return <button key={`dialUp-${num}`} onClick={() => click(num)} className={"dial-up-button"}>{num}</button>
                                })}
                                <div />
                                <button className={"dial-up-call-button"} onClick={() => onCall()} disabled={loading}>
                                    <MdCall />
                                </button>
                                <button style={backButtonStyle} onClick={() => click("backspace")} disabled={loading}>
                                    <MdBackspace />
                                </button>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            )}
        </React.Fragment>
    )
}

export default DialUp
